import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';
import logo from '../assets/images/NewLogoCut.png';
const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto max-w-7xl px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            {/* <h3 className="text-2xl font-bold mb-4">
              <span className="text-white">Sight</span>
              <span className="text-blue-400"> Vision</span>
            </h3> */}
             <img src={logo}  alt="Logo" className="mb-4 svlogo" />
            <p className="text-slate-400 mb-4">
              Leading provider of supply chain management solutions with cutting-edge technology.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-slate-400 hover:text-blue-400 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-blue-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-blue-400 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-400 hover:text-blue-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 hover:text-blue-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-blue-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services/wms" className="text-slate-400 hover:text-blue-400 transition-colors">
                  WMS
                </Link>
              </li>
              <li>
                <Link to="/services/wip" className="text-slate-400 hover:text-blue-400 transition-colors">
                  WIP Tracking
                </Link>
              </li>
              <li>
                <Link to="/services/inventory" className="text-slate-400 hover:text-blue-400 transition-colors">
                  Inventory Tracking
                </Link>
              </li>
              <li>
                <Link to="/services/asset-tracking" className="text-slate-400 hover:text-blue-400 transition-colors">
                  Asset Tracking
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-blue-400 mt-1 flex-shrink-0" />
                <span className="text-slate-400">sales@svits.com</span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-blue-400 mt-1 flex-shrink-0" />
                <span className="text-slate-400">+91 7985305845</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-blue-400 mt-1 flex-shrink-0" />
                <span className="text-slate-400">A 21 Friends AvenueColony, Sadrauna, Munnu Khera, Industrial Area (Lucknow), Lucknow, Uttar Pradesh, India, 226009</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center">
          <p className="text-slate-400">
            © {new Date().getFullYear()} Sight Vision IT Solution Pvt Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;